<!-- @format -->

<div class="timesheet">
	<div class="calendar-scroll" *ngIf="!isEditingEmployeeTimesheet">
		<div class="buttonContainer top">
			<button class="previousMonthBtn" [class.disabled]="!getHasPreviousMonthEntry()" (click)="loadPreviousMonth()">
				<i class="fa-solid fa-circle-chevron-up"></i>
			</button>
		</div>

		<div class="calendarDisplay">
			<app-calendar
				[isYearView]="false"
				[calendarData]="extractMonthlyData(calendarOneMonth, calendarOneYear)"
				[isSelectedCalendarInstance]="isCalendarOneSelected"
				[filterToggleStates]="filterToggleStates"
				[selectedTimesheet]="selectedTimesheet"
				(selectedTimesheetEmitter)="handleWeekSelected($event, true)">
			</app-calendar>

			<app-calendar
				[isYearView]="false"
				[calendarData]="extractMonthlyData(calendarTwoMonth, calendarTwoYear)"
				[isSelectedCalendarInstance]="!isCalendarOneSelected"
				[filterToggleStates]="filterToggleStates"
				[selectedTimesheet]="selectedTimesheet"
				(selectedTimesheetEmitter)="handleWeekSelected($event, false)">
			</app-calendar>
		</div>

		<div class="buttonContainer bottom">
			<button class="nextMonthBtn" [class.disabled]="!getHasNextMonthEntry()" (click)="loadNextMonth()">
				<i class="fa-sharp fa-solid fa-circle-chevron-down"></i>
			</button>
		</div>
	</div>

	<div class="weekly-view" *ngIf="selectedTimesheet">
		<button *ngIf="isEditingEmployeeTimesheet" (click)="activeModal.close()"><i class="fa-sharp fa-solid fa-xmark fa-2x"></i></button>
		<div class="dateBar">
			<div class="current-week">
				<h1 class="selectedWeekDateRange">
					{{ generateWeekRangeString(selectedTimesheet) }} <span *ngIf="editEmp">— {{empName}}</span>
				</h1>
			</div>
			<div class="payPeriodWeek">{{payperiodWeek}}</div>
		</div>

		<h4>Review and submit your timesheet for this week.</h4>
		<div class="btns-container">
			<button (click)="viewHistory()" class="btn btn-link">History <i class="fa-regular fa-history"></i></button>
			<button *ngIf="hasSubmittedTimesheet && toggleEdit && !isEditingEmployeeTimesheet" (click)="editOverride(false)" class="btn btn-link">
				Edit <i class="fa-solid fa-pencil"></i>
			</button>
			<button *ngIf="hasSubmittedTimesheet && !toggleEdit && !isEditingEmployeeTimesheet" (click)="editOverride(true)" class="btn btn-link">
				Cancel <i class="fa-solid fa-times"></i>
			</button>
		</div>
		<app-entry-form
			[selectedTimesheet]="selectedTimesheet"
			[weekOneTsHasUsedCdo]="weekOneTsHasUsedCdo"
			[currentConfiguration]="currentConfiguration"
			[selectedPayPeriodTimesheets]="selectedPayPeriodTimesheets"
			[editOverride]="toggleEdit"
			[newEntryChanges]="newEditFormChanges"
			[addedRows]="addedRows"
			(openSidebar)="open(content)"
			(saveOrSubmitTimesheet)="saveOrSubmitTimesheet($event)"
			(openEditSidebar)="openEdit($event, content)"
			(hasSubmittedTimesheetData)="hasSubmittedTimesheetData($event)"
			[timeEntryTypes]="timeEntryTypes"
			[exceptionTypes]="exceptionTypes"
			[isEditingEmployeeTimesheet]="isEditingEmployeeTimesheet">
		</app-entry-form>

		<div class="microcopy privacyInformation">
			The District of North Vancouver uses this application to facilitate the submission, review, and management of employee time entry.
			Personal information you provide is used solely for this purpose and under the authority of the Freedom of Information and Protection of
			Privacy Act, Section 26 (c), (d). If you have questions about the use of your personal information, contact the Privacy Office at
			604-990-2211 or <a href="mailto:privacy@dnv.org">privacy&#64;dnv.org</a>.
		</div>
	</div>
</div>

<ng-template #content let-offcanvas>
	<div class="offcanvas-header">
		<h4 class="offcanvas-title add-row-header" id="offcanvas-basic-title">
			<b *ngIf="!isEdit">Add a row</b>
			<b *ngIf="isEdit">Edit a row</b>
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="close()"><i class="fa-sharp fa-solid fa-xmark"></i></button>
	</div>

	<div class="offcanvas-body">
		<form [formGroup]="addRowForm" (ngSubmit)="isEdit ? editRow() : addRow()" #formDir="ngForm">
			<h5 class="row-property-title">Time Category</h5>
			<div class="add-row-select">
				<ng-select
					formControlName="type"
					[compareWith]="compareNgSelectOptions"
					(change)="resetSidebarOnTypeChange($event)"
					placeholder="Select one"
					bindLabel="entryText">
					<ng-option *ngFor="let type of timeEntryTypes" [value]="type">
						<div class="label-wrapper d-flex">
							<div [style.background]="type.colour" class="entryType"></div>
							{{type.entryText}}
						</div>
					</ng-option>
				</ng-select>
			</div>

			<div *ngIf="addRowForm.hasError('required','type') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<!-- Overtime row questions -->
			<ng-container *ngIf="currentType === 'Overtime'">
				<div class="add-row-check">
					<div class="checkboxBtn">
						<label>
							<input type="checkbox" formControlName="isWorkOrderTime" (change)="updateWorkOrderControls()" />
							<span>Charge time to Work Order</span>
						</label>
					</div>
				</div>

				<ng-container *ngIf="this.addRowForm.value?.isWorkOrderTime; else natureOfWork;">
					<h5 class="row-property-title">
						<span>Work Order number</span>
						<a data-tool-tip="Please enter the Work order number provided by your supervisor e.g. 12345678">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="workOrderNumber" />
					<div *ngIf="addRowForm.hasError('required','workOrderNumber') && formDir.submitted" class="sidebar-error-msg">
						Work order number is required
					</div>

					<h5 class="row-property-title">What did you work on during the overtime?</h5>
					<textarea class="row-notes" formControlName="workOrderDesc" maxlength="{{workOrderDescLimit}}"></textarea>
					<div *ngIf="addRowForm.hasError('required','workOrderDesc') && formDir.submitted" class="sidebar-error-msg">
						Description of the work undertaken is required
					</div>
					<div class="microcopy">{{this.addRowForm.value?.workOrderDesc?.length || 0}}/{{workOrderDescLimit}}</div>
				</ng-container>

				<ng-template #natureOfWork>
					<h5 class="row-property-title">
						<span>What did you work on during the overtime?</span>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="natureOfWorkOT" [maxlength]="natureOfWorkTextLimit" />
					<div *ngIf="addRowForm.hasError('required','natureOfWorkOT') && formDir.submitted" class="sidebar-error-msg">
						Cannot be left blank
					</div>
					<div class="microcopy">{{this.addRowForm.value?.natureOfWorkOT?.length || 0}}/{{natureOfWorkTextLimit}}</div>
				</ng-template>

				<h5 class="row-property-title">
					<span>Was this overtime prescheduled?</span>
				</h5>
				<div class="add-row-select">
					<div class="radioBtn" *ngFor="let overtimePrescheduled of overtimePrescheduledDetails">
						<label>
							<input
								type="radio"
								formControlName="prescheduledOT"
								[value]="overtimePrescheduled.code"
								(change)="checkCallout($event)" />
							{{overtimePrescheduled.entryText}}
						</label>
					</div>
				</div>
				<div *ngIf="addRowForm.hasError('required','prescheduledOT') && formDir.submitted" class="sidebar-error-msg">Make a selection</div>

				<ng-container *ngIf="showWhenOtStartRadio">
					<h5 class="row-property-title">
						<span>When did the overtime start?</span>
						<a data-tool-tip="We need this information to determine the pay rate for your overtime hours.">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<div class="add-row-select">
						<div class="radioBtn" *ngFor="let overTimeStartDetail of overTimeStartDetails">
							<label>
								<input type="radio" formControlName="adjacentOT" [value]="overTimeStartDetail.code" />
								{{overTimeStartDetail.entryText}}
							</label>
						</div>
					</div>
					<div *ngIf="addRowForm.hasError('required','adjacentOT') && formDir.submitted" class="sidebar-error-msg">Make a selection</div>
				</ng-container>

				<h5 class="row-property-title">
					<span>What would you like to do with this time?</span>
				</h5>
				<div class="add-row-select">
					<div class="radioBtn" *ngFor="let overTimeStartDetail of bankOrPayoutOptions">
						<label>
							<input type="radio" formControlName="bankOrPayoutOT" [value]="overTimeStartDetail.code" />
							{{overTimeStartDetail.entryText}}
						</label>
					</div>
				</div>
				<div *ngIf="addRowForm.hasError('required','bankOrPayoutOT') && formDir.submitted" class="sidebar-error-msg">Make a selection</div>
			</ng-container>

			<ng-container *ngIf="currentType === 'Sick'">
				<h5 class="row-property-title">Type of sick leave</h5>
				<div class="add-row-select">
					<ng-select formControlName="sickType" placeholder="Select one" [items]="sickTypeOptions" bindValue="code" bindLabel="entryText">
						<!-- <ng-select class="row-property-dropdown" formControlName="sickType" placeholder="Select one">
                        <ng-option *ngFor="let type of sickTypeOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			</ng-container>
			<div *ngIf="addRowForm.hasError('required','sickType') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<ng-container *ngIf="currentType === 'Other'">
				<h5 class="row-property-title">Type of leave</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="leaveType"
						placeholder="Select one"
						[items]="otherLeaveOptions"
						bindValue="code"
						bindLabel="entryText">
						<!-- <ng-select class="row-property-dropdown" formControlName="leaveType" placeholder="Select one">
                        <ng-option *ngFor="let type of otherLeaveOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			</ng-container>
			<div *ngIf="addRowForm.hasError('required','leaveType') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<ng-container *ngIf="currentType === 'Banked'">
				<h5 class="row-property-title">Draw from bank</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="bankedType"
						placeholder="Select one"
						[items]="bankedTypeOptions"
						bindValue="code"
						bindLabel="entryText">
						<!-- <ng-select class="row-property-dropdown" formControlName="leaveType" placeholder="Select one">
                        <ng-option *ngFor="let type of otherLeaveOptions()" [value]="type"><div class="label-wrapper d-flex">{{ type.entryText }}</div></ng-option> -->
					</ng-select>
				</div>
			</ng-container>
			<div *ngIf="addRowForm.hasError('required','bankedType') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<ng-container *ngIf="currentType === 'Union'">
				<h5 class="row-property-title">Union business</h5>
				<div class="add-row-select">
					<ng-select
						formControlName="unionBusinessType"
						placeholder="Select one"
						[items]="unionBusinessOptions"
						bindValue="code"
						bindLabel="entryText">
					</ng-select>
				</div>
			</ng-container>
			<div *ngIf="addRowForm.hasError('required','unionBusinessType') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<ng-container *ngIf="currentType === 'Regular'">
				<div class="add-row-check">
					<div class="checkboxBtn">
						<label>
							<input type="checkbox" formControlName="isWorkOrderTime" (change)="updateWorkOrderControls()" />
							<span>Charge time to Work Order</span>
						</label>
					</div>
				</div>

				<ng-container *ngIf="this.addRowForm.value?.isWorkOrderTime">
					<h5 class="row-property-title">
						<span>Work Order number</span>
						<a data-tool-tip="Please enter the Work order number provided by your supervisor e.g. 12345678">
							<i class="fa-solid fa-circle-info"></i>
						</a>
					</h5>
					<input type="text" class="add-row-input-text-field" formControlName="workOrderNumber" />
					<div *ngIf="addRowForm.hasError('required','workOrderNumber') && formDir.submitted" class="sidebar-error-msg">
						Work order number is required
					</div>

					<h5 class="row-property-title">Describe the work undertaken</h5>
					<textarea class="row-notes" formControlName="workOrderDesc" maxlength="{{workOrderDescLimit}}"></textarea>
					<div *ngIf="addRowForm.hasError('required','workOrderDesc') && formDir.submitted" class="sidebar-error-msg">
						Description of the work undertaken is required
					</div>
					<div class="microcopy">{{this.addRowForm.value?.workOrderDesc?.length || 0}}/{{workOrderDescLimit}}</div>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="currentType !== 'Overtime' && !this.addRowForm.value?.isWorkOrderTime">
				<h5 class="row-property-title">
					Comments <span class="non-bolded-heading-text" *ngIf="currentType !== 'Training'">(optional)</span>
				</h5>

				<textarea class="row-notes" formControlName="comments" maxlength="{{commentsMaxLength}}"></textarea>
				<div *ngIf="addRowForm.hasError('required','comments') && formDir.submitted" class="sidebar-error-msg">Cannot be left blank</div>
				<div class="microcopy">{{this.addRowForm.value?.comments?.length || 0}}/{{commentsMaxLength}}</div>
			</ng-container>

			<button class="add-btn" type="submit" *ngIf="!isEdit">Add</button>
			<button class="add-btn" type="submit" *ngIf="isEdit">Update</button>
		</form>
	</div>
</ng-template>

<ng-template #bankCDODialog let-modal>
	<form [formGroup]="bankCDOForm" (ngSubmit)="bankCDOFormSubmit()" #formDir="ngForm">
		<div class="modal-body-non-center">
			<h3><b>Rescheduling your CDO?</b></h3>
			<br />

			<p>Your timesheet indicates that you didn't take your scheduled CDO this week.</p>
			<p>When will you be taking this CDO?<span class="asterisk_req"></span></p>

			<ng-select
				formControlName="bankType"
				placeholder="Select one"
				[items]="cdoBankOptions"
				bindValue="code"
				bindLabel="entryText"></ng-select>

			<div *ngIf="bankCDOForm.hasError('required','bankType') && formDir.submitted" class="sidebar-error-msg">Make a selection.</div>

			<div *ngIf="selectedBankType === 'Other'" class="otherBankTypeText">
				<textarea class="bankCDOOtherTypeText" formControlName="otherTypeText" maxLength="{{bankCDOTextLimit}}"></textarea>
				<p>{{bankCDOForm.controls.otherTypeText.value.length}}/{{bankCDOTextLimit}}</p>
				<div *ngIf="bankCDOForm.hasError('required','otherTypeText') && formDir.submitted" class="sidebar-error-msg">
					Cannot be left blank
				</div>
			</div>

			<div class="buttonContainer">
				<button type="button" class="btn btn-submission-cancel" (click)="closeBankCDOModal(false)">Cancel</button>
				<button ngbAutofocus type="submit" class="btn btn-submission-bank">Confirm</button>
			</div>
		</div>
	</form>
</ng-template>

<ng-template #timesheetHistoryModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">
			History for {{ generateWeekRangeString(selectedTimesheet) }} — {{empName || profile.user.firstName + ' ' + profile.user.lastName}}
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="closeHistoryModal()"><i class="fa-solid fa-times"></i></button>
	</div>
	<div class="modal-body history">
		<div *ngFor="let timesheet of timesheetHistory; let i = index;">
			<div class="timesheet-history-meta justify-content-start d-flex">
				<div class="timesheet-history-events">
					<div *ngIf="!!timesheet.sendToJDEBy" class="event">
						<div class="img">
							<img class="profile_icon" [src]="userImages[timesheet.sendToJDEBy] || null" />
						</div>
						<div class="timesheet-history-data-section">
							<div class="timesheet-history-timestamp">{{historyTime(timesheet.sendToJDEDateTime)}}</div>
							<div class="d-flex">
								<div class="status jde">
									<i class="fa-regular fa-circle-arrow-right"></i>
								</div>
								<span>Sent to JDE</span>
							</div>
						</div>
					</div>

					<div *ngIf="!!timesheet.approvedBy" class="event">
						<div class="img">
							<img class="profile_icon" [src]="userImages[timesheet.approvedBy] || null" />
						</div>
						<div class="timesheet-history-data-section">
							<div class="timesheet-history-timestamp">{{historyTime(timesheet.approvedDateTime)}}</div>
							<div class="d-flex">
								<div class="status approved">
									<i class="fa-sharp fa-solid fa-circle-check"></i>
								</div>
								<span>{{ timesheet.approvedBy === "timesheet@dnv.org" ? "System approved" : "Timesheet approved" }}</span>
							</div>
						</div>
					</div>

					<div *ngIf="!!timesheet.submittedBy" class="event">
						<div class="img">
							<img class="profile_icon" [src]="userImages[timesheet.submittedBy] || null" />
						</div>
						<div class="timesheet-history-data-section">
							<div class="timesheet-history-timestamp">{{historyTime(timesheet.submittedDateTime)}}</div>
							<div class="d-flex">
								<div class="status submitted">
									<i class="fa-regular fa-clock"></i>
								</div>
								<span>{{ submittedAndEditedBy(timesheet, i) }}</span>
							</div>
						</div>
					</div>

					<div *ngIf="!!timesheet.savedBy" class="event">
						<div class="img">
							<img class="profile_icon" [src]="userImages[timesheet.savedBy] || null" />
						</div>
						<div class="timesheet-history-data-section">
							<div class="timesheet-history-timestamp">{{historyTime(timesheet.savedDateTime)}}</div>
							<div class="d-flex">
								<div class="status saved">
									<span class="fa-stack" style="vertical-align: top;">
										<i class="fa-regular fa-circle fa-stack-2x"></i>
										<i class="fa-sharp fa-solid fa-question fa-stack-1x"></i>
									</span>
								</div>
								<span>Saved</span>
							</div>
						</div>
					</div>
				</div>
				<div
					class="timesheet-history-view d-flex"
					[class.align-items-center]="!!timesheet.approvedBy && !!timesheet.submittedBy"
					[class.align-items-start]="(!!timesheet.approvedBy && !timesheet.submittedBy) || (!timesheet.approvedBy && !!timesheet.submittedBy) || !!timesheet.savedBy"
					[class.jde]="!!timesheet.sendToJDEBy">
					<button
						class="btn btn-link collapsed"
						type="button"
						[class.active]="selectedHistoryTS.has(i)"
						(click)="toggleSection(i)"
						[attr.aria-expanded]="timesheet"
						[attr.aria-controls]="i">
						<i class="fa-solid fa-chevron-down"></i>
						<i class="fa-solid fa-chevron-up"></i>
					</button>
				</div>
			</div>

			<div id="{{i}}" [class.collapse]="!selectedHistoryTS.has(i)">
				<app-entry-form
					[selectedTimesheet]="timesheet"
					[timeEntryTypes]="timeEntryTypes"
					[isApprovalsView]="true"
					[currentConfiguration]="currentConfiguration"
					[exceptionTypes]="exceptionTypes">
				</app-entry-form>
				<hr />
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="closeHistoryModal()">Close</button>
	</div>
</ng-template>
